import * as React from 'react';
import styled from 'styled-components';
import radialShadow from '../images/radialShadow.jpg';
import icbaBlack from '../images/financial-institutions/icbaBlack.png';
import bbow from '../images/financial-institutions/bbow.png';
import AngleRight from '../components/AngleRight';

const Section = styled.section`
	padding-top: 0;
	padding-bottom: 0;
	margin-bottom: 2em;
	background-image: ${(props) => `url('${radialShadow}')`};
	background-size: 100% 100%;
	background-position: center center;

	& .centeredWrapper {
		padding: 0;
	}

	& .padding {
		width: 100%;
		padding: 0 ${(props) => props.theme.paddingMobile};

		@media (${(props) => props.theme.mediumUp}) {
			padding: 0 ${(props) => props.theme.paddingMediumUp};
		}
	}

	& .boxes {
		align-items: center;
		@media (${(props) => props.theme.mediumUp}) {
			padding: 0 15%;
		}
	}

	& h2 {
		font-size: 21px;
	}

	& .rounded-box {
		max-width: 278px;
		min-height: 215px;
		padding: 2em 2em;
		text-align: center;
		display: flex;
		flex-direction: column;

		& a {
			display: flex;
			align-items: center;
			flex-direction: column;
			justify-content: space-between;

			& img {
				margin-bottom: 1.5em;
			}

			& span {
				white-space: nowrap;
			}
		}
	}
`;

const FinancialInstitutions = (props: any) => (
	<Section className='financialInstitutions not-centered'>
		<h2 className='blue'>Financial Institutions Using this Product</h2>
		<div className='boxes row'>
			<article className='rounded-box col-12 col-md-4'>
				<a
					href='https://www.icba.org/news/press-releases/2019/03/18/icba-bancard-and-mk-decision-partner-to-offer-real-time-loan-approvals'
					target='_blank'
					className='animate-right'
				>
					<img src={icbaBlack} alt='ICBA Bancard logo' width='193' height='120' />
					<br />
					<span>Read More<AngleRight /></span>
				</a>
			</article>
			<article className='rounded-box col-12 col-md-4'>
				<a
					href='https://bankersbank.com/products-and-services/cards/credit-card-origination/'
					target='_blank'
					className='animate-right'
				>
					<img src={bbow} alt="Bankers' Bank of Wisconsin logo" width='166' height='120' />
					<br />
					<span>Read More<AngleRight /></span>
				</a>
			</article>
		</div>
	</Section>
);

export default FinancialInstitutions;
